import { Divider, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { usePortfolioRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import type {
	PortfolioListItemResponseDTO,
	PortfolioListReportingSummaryResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { PortfolioListItemTitle } from "web_myplann/Portfolio/Components/PortfolioSections/PortfolioListItemTitle";
import { PortfolioListItemRedesign } from "web_myplann/Portfolio/Components/Redesign/PortfolioListItemRedesign";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";

type Props = {
	portfolios: PortfolioListItemResponseDTO[];
	reportingData: PortfolioListReportingSummaryResponseDTO[] | undefined;
};

export const DashboardPortfolioList: FC<Props> = ({
	portfolios,
	reportingData,
}) => {
	const { spacingTokens } = useTheme();
	const navigate = useNavigate();
	const { hasRight: hasPortfolioRight } = usePortfolioRightOptional();

	return (
		<Stack
			gap={spacingTokens.lg}
			mt={spacingTokens.md}
			pb={spacingTokens.lg}
			divider={<Divider variant="hairline" />}
		>
			{portfolios.map((item) =>
				hasPortfolioRight ? (
					<PortfolioListItemRedesign
						key={item.id}
						item={{ kind: PortfolioItemKind.Portfolio, data: item }}
						summaryData={reportingData}
					/>
				) : (
					<PortfolioListItemTitle
						key={item.id}
						data={item}
						summaryData={reportingData}
						onClick={() =>
							navigate(
								Routing.Portfolio.PortfolioDetail.path(item.id.toString()),
							)
						}
					/>
				),
			)}
		</Stack>
	);
};
